import { render } from "./PaymentManagement.vue?vue&type=template&id=53d04c70&scoped=true"
import script from "./PaymentManagement.vue?vue&type=script&lang=js"
export * from "./PaymentManagement.vue?vue&type=script&lang=js"

import "./PaymentManagement.vue?vue&type=style&index=0&id=53d04c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d04c70"]])

export default __exports__